<div class="image-popup-container">
  <div class="modal-header">
    <h2>{{ 'DeliveryProofs' | translate }}</h2>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="image-section">
      <div class="image-card">
        <h3>{{ 'DigitalSignature' | translate }}</h3>
        <div class="image-wrapper" [class.no-image]="!data.digitalSignature">
          <ng-container *ngIf="data.digitalSignature; else noSignature">
            <img 
              [src]="data.digitalSignature" 
              alt="Digital Signature"
              class="document-image"
            />
          </ng-container>
          <ng-template #noSignature>
            <div class="no-image-content">
              <mat-icon>image_not_supported</mat-icon>
              <p>{{ 'NoSignatureAvailable' | translate }}</p>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="image-card">
        <h3>{{ 'ItemImage' | translate }}</h3>
        <div class="image-wrapper" [class.no-image]="!data.itemImage">
          <ng-container *ngIf="data.itemImage; else noItemImage">
            <img 
              [src]="data.itemImage" 
              alt="Item Image"
              class="document-image"
            />
          </ng-container>
          <ng-template #noItemImage>
            <div class="no-image-content">
              <mat-icon>image_not_supported</mat-icon>
              <p>{{ 'NoImageAvailable' | translate }}</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
